﻿import {currentCulture, FormattableString, isNullOrEmpty} from "@2d-front-monorepo/core";
import {JSX, ReactNode, useMemo} from "react";
import {useControlId} from "../helpers/useControlId";
import MaterialIcon from "../MaterialIcon";

export type MessageType = "error" | "warning" | "information" | "success" | "";

export type MessageProps = {
	title: FormattableString;
	detail?: FormattableString;
	footer?: FormattableString;
	items?: FormattableString[];
	type?: MessageType;
	ref?: React.Ref<HTMLDivElement>;
	children?: ReactNode;
};

export default function Message({title, detail, items, footer, type, ref, children}: MessageProps): JSX.Element {
	const controlId = useControlId();
	const ariaLive = type === "error" || type === "warning" ? "assertive" : "polite";
	const klass = useMemo(() => {
		return "form-message" + (isNullOrEmpty(type) ? "" : " form-message--" + type);
	}, [type]);

	const locale = currentCulture();

	return <div className={klass} role="alert" aria-labelledby={controlId} aria-live={ariaLive} ref={ref}>
		<div className="form-message__icon material-symbols-rounded"></div>
		<div className="form-message__contents">
			<h6 id={controlId}>{locale.format(title)}</h6>
			{detail ? <p>{locale.format(detail)}</p> : null}
			{items != null && items.length > 0 ?
				<ul>
					{items.map((item, index) => {
						return <li key={index}><MaterialIcon icon={"chevron_right"}/> {locale.format(item)}</li>;
					})}
				</ul>
				: null}
			{children}
			{footer ? <div><small>{locale.format(footer)}</small></div> : null}
		</div>
	</div>;
}
